import React from 'react'

const TabPanel = ({children, active, className, ...root}) => {
  return (
    <div
      className={`${active ? 'c-tab__panel--active' : ''} c-tab__panel ap-scrollbar ${className}`}
      {...root}
    >
      {children}
    </div>
  )
}

export default TabPanel
